import { render } from "./CreateEditModal.vue?vue&type=template&id=03646aca&scoped=true"
import script from "./CreateEditModal.vue?vue&type=script&lang=js"
export * from "./CreateEditModal.vue?vue&type=script&lang=js"

import "./CreateEditModal.vue?vue&type=style&index=0&id=03646aca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03646aca"]])

export default __exports__